module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Wi-fi-b2d3ff2cabe981bac673ef1c352e33e1.svg";